// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// aliased
import Link from 'components/Link';

// local
import styles from './Menu.pcss';

export default class Menu extends PureComponent {
  
  static propTypes = {
    className: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape({
      to: PropTypes.string.isRequired,
      children: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      icon: PropTypes.node.isRequired,
    })),
    onLinkClick: PropTypes.func,
  }
  static defaultProps = {
    onLinkClick: () => {},
    links: [],
  }
  
  render() {
    const { className, onLinkClick, links } = this.props;
    const classNames = classnames(className, styles.links);

    return (
      <div className={ classNames }>
        {
          links.map((link, i) => (
            // eslint-disable-next-line react/jsx-no-bind
            <Link to={ link.to } key={ i } className={ styles.link } onClick={ () => onLinkClick(link) }>
              <div className={ styles.inner }>
                <div className={ styles.icon }>
                  {
                    (typeof link.icon === 'string')
                      ? (<img alt={ 'icon' } src={ link.icon } />)
                      : link.icon
                  }
                </div>
                <div className={ styles.text }>
                  { link.children }
                </div>
              </div>
            </Link>
          ))
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/Menu/index.jsx